/* eslint-disable import/prefer-default-export */
import {
  makeStyles as muiMakeStyles,
  withStyles as muiWithStyles,
  useTheme as muiUseTheme,
  styled as muiStyled,
} from '@material-ui/core/styles';

export const makeStyles = muiMakeStyles;
export const buildUseStyles = (name, stylesFn) => {
  return muiMakeStyles(stylesFn, { name });
};
export const withStyles = muiWithStyles;
export const useTheme = muiUseTheme;
export const styled = muiStyled;
